/**
 * Populate claims table with appropriate description
 * @param {Object} claims ID token claims
 * @returns claimsObject
 */

/**
 * Export the entire token object
 *
 */
export const getTokenClaims = (claims) => {
  let claimsObj = {};
  let index = 0;
  Object.keys(claims).forEach((key) => {
    if (typeof claims[key] !== "string" && typeof claims[key] !== "number")
      return;
    switch (key) {
      //  "This is the Given Name set by the user on the sign up page"
      case "given_name":
        populateClaim(key, claims[key], index, claimsObj);
        index++;
        break;
      // "This is the Family Name set by the user on the sign up page",
      case "family_name":
        populateClaim(key, claims[key], index, claimsObj);
        index++;
        //"This is the email that is used for login",
        populateClaim("Email", claims.emails[0], index, claimsObj);
        index++;
        break;
      //"This is the display name set by the user on the sign up page",
      case "name":
        populateClaim(key, claims[key], index, claimsObj);
        index++;
        break;

      default:
      // populateClaim(key, claims[key], "", index, claimsObj);
      // index++;
    }
  });
  return claimsObj;
};
/**
 * Populates claim, description, and value into an claimsObject
 * @param {String} claim
 * @param {String} value
 * @param {Number} index
 * @param {Object} claimsObject
 */
const populateClaim = (claim, value, index, claimsObject) => {
  let claimsArray = [];
  claimsArray[0] = claim;
  claimsArray[1] = value;
  claimsObject[index] = claimsArray;
};
// const populateClaim = (claim, value, description, index, claimsObject) => {
//   let claimsArray = [];
//   claimsArray[0] = claim;
//   claimsArray[1] = value;
//   claimsArray[2] = description;
//   claimsObject[index] = claimsArray;
// };

/**
 * Transforms Unix timestamp to date and returns a string value of that date
 * @param {String} date Unix timestamp
 * @returns
 */
// const changeDateFormat = (date) => {
//   let dateObj = new Date(date * 1000);
//   return `${date} - [${dateObj.toString()}]`;
// };
/**
 * Compare the token issuing policy with a specific policy name
 * @param {object} idTokenClaims - Object containing the claims from the parsed token
 * @param {string} policyToCompare - ID/Name of the policy as expressed in the Azure portal
 * @returns {boolean}
 */
export function compareIssuingPolicy(idTokenClaims, policyToCompare) {
  let tfpMatches =
    idTokenClaims.hasOwnProperty("tfp") &&
    idTokenClaims["tfp"].toLowerCase() === policyToCompare.toLowerCase();
  let acrMatches =
    idTokenClaims.hasOwnProperty("acr") &&
    idTokenClaims["acr"].toLowerCase() === policyToCompare.toLowerCase();
  return tfpMatches || acrMatches;
}
